import { render } from "./Panel.vue?vue&type=template&id=d7b2465e&scoped=true&ts=true"
import script from "./Panel.vue?vue&type=script&lang=ts"
export * from "./Panel.vue?vue&type=script&lang=ts"

import "./Panel.vue?vue&type=style&index=0&id=d7b2465e&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/apps/builder-legacy/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7b2465e"]])

export default __exports__